/* Small, deterministic wall model shared by previews, thumbnails and tests. */
(function (scope) {
  'use strict';
  var colours = {warm:'#f3f0e9', stone:'#e5e0d6', grey:'#e4e5e3'};
  function presets(count) {
    if (count < 2) return [{id:'row',label:'Centred'}];
    if (count === 2) return [{id:'row',label:'Side by side'},{id:'stacked',label:'Stacked'},{id:'staggered',label:'Staggered'}];
    if (count === 3) return [{id:'row',label:'In a row'},{id:'feature',label:'Feature wall'},{id:'staggered',label:'Staggered'}];
    return [{id:'grid',label:'Grid'},{id:'row',label:'In a row'},{id:'feature',label:'Feature wall'}];
  }
  function compatible(layout, count) {
    var choices = presets(count);
    return choices.some(function (p) { return p.id === layout; }) ? layout : choices[0].id;
  }
  function normalise(wall) {
    var result = Object.assign({}, wall);
    result.layout = compatible(wall.layout, wall.artworks.length);
    result.spacing = ['close','regular','airy'].includes(wall.spacing) ? wall.spacing : 'regular';
    result.wallColour = Object.hasOwn(colours, wall.wallColour) ? wall.wallColour : 'warm';
    return result;
  }
  function geometry(artworks, layout, spacing) {
    if (!artworks.length) return [];
    layout = compatible(layout, artworks.length);
    var gap = {close:22,regular:44,airy:76}[spacing] || 44;
    var boxes = artworks.map(function (a) { return {x:0,y:0,width:Math.max(.01, Number(a.aspectRatio) || 1) * 300,height:300}; });
    function size(index, height) { var b=boxes[index]; b.width=b.width/b.height*height; b.height=height; }
    function row(indices, y, height) {
      var x=0;indices.forEach(function (index) {size(index,height);boxes[index].x=x;boxes[index].y=y;x+=boxes[index].width+gap;});
      return x-gap;
    }
    var ids=boxes.map(function (_,i) { return i; });
    if (boxes.length === 1) size(0,460);
    else if (layout === 'row' || layout === 'staggered') {
      row(ids,0,360);
      if (layout === 'staggered') boxes.forEach(function (b,i) { b.y=boxes.length===2 ? i*100 : [50,-55,80][i]; });
    } else if (layout === 'stacked') {
      var maxWidth=Math.max.apply(null,boxes.map(function (b) {return b.width;}));
      boxes.forEach(function (b,i) {b.x=(maxWidth-b.width)/2;b.y=i*(300+gap);});
    } else if (layout === 'feature' && boxes.length === 3) {
      size(0,460);size(1,285);size(2,285);
      boxes[1].x=0;boxes[1].y=88;
      boxes[0].x=boxes[1].width+gap;
      boxes[2].x=boxes[0].x+boxes[0].width+gap;boxes[2].y=88;
    } else if (layout === 'feature') {
      size(0,500);
      var cols=boxes.length>4?2:1, rows=Math.ceil((boxes.length-1)/cols), widths=[];
      for(var i=1;i<boxes.length;i++){size(i,(500-gap*(rows-1))/rows);widths[(i-1)%cols]=Math.max(widths[(i-1)%cols]||0,boxes[i].width);}
      for(var j=1;j<boxes.length;j++){var col=(j-1)%cols;boxes[j].x=boxes[0].width+gap+(col?widths[0]+gap:0)+(widths[col]-boxes[j].width)/2;boxes[j].y=Math.floor((j-1)/cols)*(boxes[j].height+gap);}
    } else {
      var columns=boxes.length>4?3:2, rowCount=Math.ceil(boxes.length/columns), rowWidths=[];
      for(var r=0;r<rowCount;r++) rowWidths.push(row(ids.slice(r*columns,(r+1)*columns),r*(300+gap),300));
      var widest=Math.max.apply(null,rowWidths);
      boxes.forEach(function (b,i) {b.x+=(widest-rowWidths[Math.floor(i/columns)])/2;});
    }
    var left=Math.min.apply(null,boxes.map(function (b) {return b.x;})), top=Math.min.apply(null,boxes.map(function (b) {return b.y;}));
    var width=Math.max.apply(null,boxes.map(function (b) {return b.x+b.width;}))-left;
    var height=Math.max.apply(null,boxes.map(function (b) {return b.y+b.height;}))-top;
    var scale=Math.min(840/width,500/height);
    return boxes.map(function (b) {return {x:(1000-width*scale)/2+(b.x-left)*scale,y:(650-height*scale)/2+(b.y-top)*scale,width:b.width*scale,height:b.height*scale};});
  }
  var model={presets:presets,compatible:compatible,normalise:normalise,geometry:geometry,colours:colours};
  if (typeof module !== 'undefined' && module.exports) module.exports=model;
  else scope.UMMyCollectionWall=model;
})(typeof window !== 'undefined' ? window : this);
